import { render, staticRenderFns } from "./addExpert.vue?vue&type=template&id=20505808"
import script from "./addExpert.vue?vue&type=script&lang=js"
export * from "./addExpert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports